var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90009 9.43452L11.0497 5.24922C11.2091 5.0896 11.4247 5 11.6494 5C11.8741 5 12.0897 5.0896 12.249 5.24922C12.3288 5.3289 12.392 5.42369 12.4352 5.52812C12.4784 5.63256 12.5006 5.74458 12.5006 5.85772C12.5006 5.97086 12.4784 6.08288 12.4352 6.18732C12.392 6.29176 12.3288 6.38655 12.249 6.46622L7.4955 11.2515C7.33707 11.4098 7.12323 11.4991 6.90009 11.5C6.78815 11.5007 6.67718 11.479 6.57355 11.4364C6.46991 11.3937 6.37566 11.3309 6.29618 11.2515L4.29731 9.22883C4.20827 9.152 4.13596 9.05746 4.0849 8.95113C4.03385 8.8448 4.00516 8.72898 4.00063 8.61095C3.99611 8.49292 4.01585 8.37522 4.05861 8.26524C4.10137 8.15526 4.16624 8.05537 4.24913 7.97185C4.33202 7.88833 4.43116 7.82297 4.54031 7.77988C4.64946 7.7368 4.76627 7.71691 4.88341 7.72147C5.00055 7.72603 5.11549 7.75493 5.22102 7.80638C5.32655 7.85782 5.42038 7.93068 5.49663 8.0204L6.90009 9.43452Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.212ebcc6ab0c8663692bd69fbaf2bf26.svg";
export { ForwardRef as ReactComponent };